import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Sort, SortDirection } from '@angular/material/sort';
import { Actions } from 'bqx-deal';
import { LoggerAbstractService, LogLevel } from 'bqx-logging';
import { QuoteInfo } from 'src/app/models/application-form/search-detail.model';
import { ApplicationFormAbstractService } from 'src/app/services/application-form/application-form.abstract.service';
import { AbstractDealAnalyticsService } from 'src/app/services/deal-analytics/abstract-deal-analytics.service';

@Component({
  selector: 'app-search-detail',
  templateUrl: './search-detail.component.html',
  styleUrls: ['./search-detail.component.css']
})
export class SearchDetailComponent implements OnInit {

  @Input() dataSource: any;
  @Input() activeSortColumn: string;
  @Input() activeSortDirection: SortDirection;
  @Input() displayedColumns: string[];
  @Output() viewButtonClick = new EventEmitter<QuoteInfo>();
  @Output() sortChange = new EventEmitter<Sort>();
  private _user: string;

  constructor(
    private dealAnalyticsService: AbstractDealAnalyticsService,
    private loggerService: LoggerAbstractService,
    private applicationFormService: ApplicationFormAbstractService
  ) { }

  ngOnInit(): void {
    this._user = JSON.parse(localStorage.getItem('client-user'))?.Username;
    if (this.applicationFormService.dashboardFlag) {
      const success = this.dataSource?.filteredData.length > 0;
      const result = {
        success: success,
        user: this._user
      }
      this.loggerService.postLogData(LogLevel.Info, 'Search Page Loaded From Dashboard', JSON.stringify(result), '');
      this.applicationFormService.dashboardFlag = false;
    }
  }

  public viewButtonOnClick(id: string, reference_id: string): void {
    const quoteInfo: QuoteInfo = {
      id: id,
      quoteNumber: reference_id
    }
    sessionStorage.setItem('quoteNumber', reference_id);
    sessionStorage.setItem('ssid', id);
    sessionStorage.setItem('isQuoteRetrieval', 'true');
    this.dealAnalyticsService.postDealControlEvent(Actions.ButtonClick, 'View - Search', '/search_forms', 'Search');
    const guid = crypto.randomUUID(); //  guid is only used to pair logging attempt/success statements for dashboard/querying
    const result = {
      quoteNumber: reference_id,
      user: this._user,
      guid: guid
    }
    this.loggerService.postLogData(LogLevel.Info, 'View Button on Search Page Clicked', JSON.stringify(result), '');
    this.applicationFormService.searchPageUser = this._user;
    this.applicationFormService.searchPageGUID = guid;
    this.viewButtonClick.emit(quoteInfo);
  }
  public sortData(sort: Sort): void {
    this.sortChange.emit(sort);
  }
}
